<template>
	<Icon :size="size">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke-width="1.5"
			stroke="currentColor"
			v-show="!tipoOrdem"
		>
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
			/>
		</svg>

		<svg
			v-show="tipoOrdem == 'asc'"
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke-width="1.5"
			stroke="currentColor"
		>
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				d="M15.75 17.25L12 21m0 0l-3.75-3.75M12 21V3"
			/>
		</svg>
    
		<svg
			v-show="tipoOrdem == 'desc'"
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke-width="1.5"
			stroke="currentColor"
		>
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				d="M8.25 6.75L12 3m0 0l3.75 3.75M12 3v18"
			/>
		</svg>
	</Icon>
</template>

<script>
import Icon from './Icon.vue'
import IconMixin from './IconMixin.js'
export default {
	mixins: [IconMixin],
	components: {
		Icon
	},
  props: {
    tipoOrdem: {
      type: String
    }
  }
}
</script>